<template>
  <div>
    <div class="db-filter-modal">
      <div class="db-filter-title-text">Add Internasional</div>

      <div class="db-filter-half-input-wrapper">
        <div class="db-filter-hiw-label">Deskripsi</div>
        <div class="db-filter-hiw-full">
          <input type="text" class="db-filter-hiw-text" v-model="editData.desc" />
        </div>
      </div>
      <div class="db-filter-half-input-wrapper">
        <div class="db-filter-hiw-label">Alias pada Profil</div>
        <div class="db-filter-hiw-full">
          <input type="text" class="db-filter-hiw-text" v-model="editData.alias_profile" />
        </div>
      </div>
      <div class="db-filter-half-input-wrapper">
        <div class="db-filter-hiw-label">Alias pada SAP</div>
        <div class="db-filter-hiw-full">
          <input type="text" class="db-filter-hiw-text" v-model="editData.alias_sap" />
        </div>
      </div>
      <div class="db-filter-half-input-wrapper">
        <div class="db-filter-hiw-label">Catatan</div>
        <div class="db-filter-hiw-full">
          <input type="text" class="db-filter-hiw-text" v-model="editData.note" />
        </div>
      </div>
      <div class="db-filter-half-input-wrapper">
        <div class="db-filter-hiw-label">Status</div>
        <div class="db-filter-hiw-multiple">
          <select class="db-filter-hiw-select" v-model="editData.is_active">
            <option :value="true">Active</option>
            <option :value="false">Inactive</option>
          </select>
        </div>
      </div>
      <div class="button-container">
        <div class="button-wrapper">
          <div class="email-button" @click="closeModal">CANCEL</div>
          <div class="email-button" @click="update">CONFIRM</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { api } from '@/services/config'
export default {
  data() {
    return {
      editData: {
        desc: '',
        alias_profile: '',
        alias_sap: '',
        note: '',
        is_active: true,
        bidang_usaha_id: 2,
        type_pendaftaran_id: 2,
      }
    }
  },

  methods: {
    closeModal() {
      this.$emit('closeModal')
    },
    async update() {
      try {
        await this.$store.commit('SET_GLOBAL_LOADING', true)
        const { data } = await axios({
          method: 'POST',
          url: `${api}/api/v1/badan-usaha`,
          data: this.editData
        })

        if (data && data.status === 'success') {
          this.$emit('closeModal')
          await this.$store.commit(
            'SET_NOTIF',
            'Berhasil manambah data',
          )
          await this.$store.dispatch('mdMatrixLegalStore/getBadanUsaha')
          await this.$store.commit('SET_GLOBAL_LOADING', false)
        }
      } catch (error) {
        await this.$store.commit(
          'SET_NOTIF',
          error.response.data.message,
        )
        await this.$store.commit('SET_GLOBAL_LOADING', false)
      }
    },
  }
}
</script>